module.exports = __webpack_public_path__ + "img/base_divers_poussette.f07fa02e.svg";